import { store } from '@longsien/react-store';

export const parkingAvailabilityStore = store(null);
